<div class="dynamic-textarea">
    <mat-form-field appearance="outline" *ngIf="editMode">
      <mat-label>{{data.columnName}}</mat-label>
      <textarea matInput [placeholder]="data.columnName" [(ngModel)]="data.value"></textarea>
    </mat-form-field>
    
    <mat-label *ngIf="data.value != null && !editMode" style="font-size: 10px;">{{data.columnName}}</mat-label>
    <mat-chip-list *ngIf="!editMode" class="chip-edit" >
      <mat-chip *ngIf="data.value != null" class="chip-edit" color="primary" selected (click)="switchEditingMode()"> 
        {{getShortValue(data.value)}}
      </mat-chip>
      <mat-chip (click)="switchEditingMode()" *ngIf="!data.value"> 
        {{data.columnName}}: 
      </mat-chip>
    </mat-chip-list>
    
    <i class="fas fa-solid fa-angle-up icon" *ngIf="editMode" (click)="switchEditingMode()"></i>
  </div>